const stylesMenu = {
  button: {
    textTransform: "capitalize",
    fontWeight:"normal",
    fontSize: "17px",
    textDecoration: "none",
  },
};

export default stylesMenu;
